import request from "./request";

const QuizService = {
    GetDashboard: async (context, signal) => {
        return await request.sendRequest(`/quiz/master/dashboard`, context.token, signal);
    },
    GetCourseWiseDashboard: async (context, signal) => {
        return await request.sendRequest(`/quiz/master/dashboard/courses`, context.token, signal);
    },
    GetCalender: async (context, startDate, endDate, signal) => {
        return await request.sendRequest(`/quiz/master/dashboard/calendar/${startDate}/${endDate}`, context.token, signal);
    },
    GetAllQuizzes: async (context, signal) => {
        return await request.sendRequest(`/quiz/all/quizzes`, context.token, signal);
    },
    GetAllUserQuizzes: async (context, signal) => {
        return await request.sendRequest(`/quiz/all/user/quizzes`, context.token, signal);
    },
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/quiz/all/quiz`, context.token, signal);
    },
    GetList: async (context, signal) => {
        return await request.sendRequest(`/quiz/list/quiz`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/quiz/${id}`, context.token, signal);
    },
    GetSessions: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/quizmcqexam/sessions/${id}/${searchText}`, context.token, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/quiz`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/quiz/${id}`, context.token);
    },
};

export default QuizService;
